<template>
	<el-container :style="'height: '+$store.state.height+'px'">
		<el-aside :width="menuwidth">
			<el-row>
				<el-col :span="24">
					<div class="head-logo">
						<div class="logo-img-div">
							<img :src="$store.state.main.qaedas==null?require('../../assets/logo.png'):(this.config.apiurl + $store.state.main.qaedas.image)" alt="" class="logo-img">
						</div>
						<div class="logo-img-title" v-show="!isOpen">
							{{$store.state.main.qaedas==null?'智慧农业云平台':$store.state.main.qaedas.name}}
						</div>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<div class="mune-main">主菜单</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-menu
					  :collapse="isOpen"
					  :default-active="menuIndex" 
					  background-color="#222d32"
					  text-color="#b8c7ce"
					  active-text-color="white"
					  router>
						<div v-for="(items,index) in menu" :key="index">
							<el-menu-item v-if="items.submenu.length==0" @click="openmune($store.state.isphone)" :index="items.link" v-bind:class="{ menuselect: menuIndex==items.link}" :title="items.name">
								<i :class="items.icon"></i>
								<span slot="title">{{items.name}}</span>
							</el-menu-item>
							<el-menu-item v-else-if="items.id=='0'&&items.submenu.length==0" @click="openmune($store.state.isphone)" title="暂无数据!" disabled>
								<i :class="items.icon"></i>
								<span slot="title">{{items.name}}</span>
							</el-menu-item>
							<el-submenu v-else :index="items.link +'?id=' + items.id">
								<template slot="title">
									<i :class="items.icon"></i> 
									<span slot="title" v-show="!isOpen">{{items.name}}</span>
								</template>
								<el-menu-item v-for="(item,index) in items.submenu" @click="openmune($store.state.isphone)" :key="index" v-bind:class="{ menuselect: menuIndex==item.link }" :index="item.link" :title="item.name">
									<div slot="title" class="cdcd dh2j"><i :class="item.icon"></i> {{item.name}}</div>
								</el-menu-item>
							</el-submenu>
						</div>
					</el-menu>
				</el-col>
			</el-row>
			<el-row v-show="!isOpen">
				<el-col :span="24">
					<div class="mune-about">相关链接</div>
				</el-col>
			</el-row>
			<el-row v-show="!isOpen">
				<el-col :span="24" v-show="$store.state.main.qaedas.video_system==1">
					<div class="mune-about-url" @click="moveto('/video/show')"><i class="my-icon-jkgl"></i>视频监控</div>
				</el-col>
				<el-col :span="24" v-show="$store.state.main.qaedas.trace_system==1">
					<div class="mune-about-url" @click="moveto('/traceability/retrospect')"><i class="my-icon-sy"></i>追溯管理</div>
				</el-col>
				<el-col :span="24" v-show="$store.state.main.qaedas.production_system==1">
					<div class="mune-about-url" @click="moveto('/production/record')"><i class="my-icon-shc"></i>生产信息</div>
				</el-col>
				<el-col :span="24" v-show="$store.state.main.user.m_qaedas_id==0">
					<div class="mune-about-url" @click="moveto('/main')"><i class="my-icon-jidi"></i>基地管理</div>
				</el-col>
				<el-col :span="24" v-if="$store.state.main.user.isAlarm==2">
					<div class="mune-about-url" @click="moveto('/warning')"><i class="my-icon-yujing"></i>设备预警</div>
				</el-col>
			</el-row>
		</el-aside>
		<el-container>
			<el-header height="50px">
				<el-row>
					<el-col :span="4" class="header-left">
						<el-button icon="my-icon-menu" class="menu-button" @click="openmune(true)"></el-button>
					</el-col>
					<el-col :span="16" class="header-center">
						<span v-if="$store.state.isphone">后台管理</span>
						<span v-else>&nbsp;</span>
					</el-col>
					<el-col :span="4" class="header-right">
						<el-dropdown @command="userclick">
							<div class="header-user-div">
								<img :src="userdata.avatar==null?'../assets/logo.png':(config.apiurl+userdata.avatar)" alt="" class="header-user-img">
								<br />
								<span>{{userdata.username==null?"admin":userdata.username}}</span>
							</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="set">个人信息</el-dropdown-item>
								<el-dropdown-item command="out">退出登录</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</el-col>
				</el-row>
			</el-header>
			<el-main v-loading="$store.state.mainload" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
				<div class="div-main" :style="'height: '+($store.state.height-80-($store.state.isphone?10:40))+'px;'">
					<router-view />
				</div>
			</el-main>
			<el-footer height="30px">
				<el-row>
					<el-col :span="8" v-show="!$store.state.isphone" class="footer-left">{{$store.state.main.qaedas==null?'智慧农业云平台':$store.state.main.qaedas.name}}</el-col>
					<el-col :span="8 + (!$store.state.isphone?0:16)" class="footer-center">技术支持：<a href="http://www.farmereasy.com/" target="view_window">成都市易农科技有限公司</a></el-col>
					<el-col :span="8" v-show="!$store.state.isphone" class="footer-right">{{time}}</el-col>
				</el-row>
			</el-footer>
		</el-container>
	</el-container>
</template>

<script>
	export default {
		data() {
			return {
				drawer: false,
				menuwidth: "250px",
				isOpen: false,
				menuIndex: "Carousel",
				time: null,
				userdata: {},
				menu: [
					{
						id: "-1",
						name: "认领记录管理",
						icon: "my-icon-renling",
						link: "Claimrecord",
						submenu: []
					},
					{
						id: "-2",
						name: "合同签订管理",
						icon: "my-icon-hetong",
						link: "Contract",
						submenu: []
					},
					{
						id: "-3",
						name: "栅栏信息管理",
						icon: "my-icon-zhalan",
						link: "Fence",
						submenu: []
					},
					{
						id: "-4",
						name: "物种信息管理",
						icon: "my-icon-zhl",
						link: "Species",
						submenu: []
					},
					{
						id: "-5",
						name: "物种详情管理",
						icon: "my-icon-zhiwu",
						link: "Speciesdetails",
						submenu: []
					}
				],
				city: [],
				lat: '',
				lng: '',
				birthday: '',
				userform: {
					avatar: '',
					username: '',
					nickname: '',
					idCard: '',
					gender: '',
					city: '',
					birthday: '',
					bio: '',
					latLong: '',
					address: ''
				},
				props: {
					checkStrictly: true,
					value: 'id',
					label: 'name',
					children: 'children',
					lazy: true,
					lazyLoad: (node, resolve)=>{
						let val=node.path;
						if(this!=null)
						{
							this.loadadr(val)
							.then((adr) => {
								resolve(adr);
							});
						}
					}
				}
			};
		},
		watch: {
			$route: {
				handler: function(val, oldVal){
					this.menuselect();
				},
				// 深度观察监听
				deep: true
			}
		},
		methods: {
			load()
			{
				this.menuselect();
				this.getusers();
				this.nowtime();
				this.getqaedas({id: this.getCookie(this.config.jdid)});
			},
			getHeight() {
				let body = document.getElementsByTagName("body");
				if(this.$store.state.isphone)
				{
					this.menuwidth="0px";
					this.isOpen=true;
					body[0].style.width="";
				}
				else
				{
					this.menuwidth="250px";
					this.isOpen=false;
					body[0].style.width="";
				}
			},
			openmune(sub)
			{
				if(sub)
				{
					this.isOpen=!this.isOpen;
					let wid=this.isOpen?64:250;
					let body = document.getElementsByTagName("body");
					if(this.isOpen&&this.$store.state.isphone)
					{
						wid-=64;
						body[0].style.width="";
					}
					if(!this.isOpen&&this.$store.state.isphone)
					{
						body[0].style.width=this.$store.state.width+16+250+"px";
					}
					this.menuwidth=wid+"px";
				}
			},
			menuselect()
			{
				let sel={
					Claimrecord: "Claimrecord",
					Contract: "Contract",
					Fence: "Fence",
					Species: "Species",
					Speciesdetails: "Speciesdetails"
				}
				let url = this.$route.path;
				let select=url.split('/')[url.split('/').length-1];
				this.menuIndex=sel[select];
			},
			nowtime()
			{
				let _this = this;
				this.timer = setInterval(() => {
				_this.time = this.Totime(new Date().getTime()/1000); 
				}, 1000)
			},
			userclick(command)
			{
				if(command=='out')
				{
					this.logoutM();
				}
				else if(command=='set')
				{
					// this.drawer=true;
					// this.$nextTick(()=>{
					// 	this.$refs['userform'].resetFields();
					// 	this.birthday=new Date(this.userdata.birthday);
					// 	this.setdata(this.userform,this.userdata);
					// });
					this.$router.push("userset");
				}
			},
			getusers()
			{
				this.getuser()
				.then((response)=>{
					this.userdata=response.data.data;
				});
			},
			moveto(value)
			{
				this.$router.push({path:value});
			},
			addlatlng()
			{
				let adr = this.$refs["EAadr"].presentText;
				if(adr==null)
				{
					return;
				}
				// 创建地址解析器实例
				var myGeo = new BMap.Geocoder();
				myGeo.getPoint(adr, (point)=>{
					if (point) {
						this.lng=point.lng;
						this.lat=point.lat;
					}else{
						this.$message({
							message: "解析错误!",
							type: 'error',
							center: true,
						});
					}
				});
			}
		},
		mounted: function () {
			this.load();
		},
		created() {
			window.addEventListener('resize', this.getHeight);
			this.getHeight()
		},
		destroyed() {
			window.removeEventListener('resize', this.getHeight)
		}
	}
</script>

<style scoped>
	.el-header, .el-footer {
		background-color: #18bc9c;
	}
	.el-aside {
		background-color: #222d32;
	}
	.el-main{
		background-color: #f0f0f0;
		overflow-y: hidden;
		padding: 0px;
	}
	.div-main{
		padding: 20px;
		overflow-y: auto;
	}
	.head-logo{
		background-color: #15a589;
	}
	.menuselect{
		background-color: #18bc9c !important;
		text-color:white;
	}
	
	.el-header{
		padding: 0px;
	}
	.el-footer,.el-main,.el-aside,.el-header {
		overflow-x: hidden;
	}
	.el-footer,.el-header {
		overflow-y: hidden;
	}
	.el-aside {
		transition: width 0.5s;
	}
	.head-logo{
		height: 50px;
	}
	.logo-img{
		width: 44px;
		height: 44px;
		border-radius: 50%;
		margin: 3px;
		background-color: white;
	}
	.logo-img-title{
		float: left;
		width: auto;
		line-height: 50px;
	}
	.logo-img-div{
		float: left;
		width: 60px;
		height: 50px;
		text-align: center;
	}
	.el-menu {
		border-right: 0px;
	}
	.menu-button{
		border-radius: 0px;
		height: 50px;
		border: 0px;
		padding: 12px 15px;
		background-color: #099076;
		color: white;
	}
	.menu-button:hover,.menu-button:focus{
		background-color: #667976 !important;
		color: white;
	}
	.mune-main{
		/* background-color: #42B983;
		padding: 8px 5px; */
		background-color: #7C7F86;
		padding: 8px 5px;
		color: white;
		font-weight: 800;
	}
	.mune-about{
		/* background-color: #7C7F86; */
		background-color: #7C7F86;
		padding: 8px 5px;
		color: white;
		font-size: 14px;
	}
	.mune-about-url{
		background-color: #222d32;
		/* #CCCCCC; */
		padding: 6px 0px;
		padding-left: 30px;
		color:#b8c7ce;
		/* border-bottom: 1px solid #A9A9A9; */
		cursor: pointer;
		font-size: 13px;
	}
	.mune-about-url:hover{
		background-color: #36383e;
		color: white;
	}
	.header-left{
		
	}
	.header-center{
		text-align: center;
		line-height: 50px;
		font-size: 20px;
	}
	.header-right{
		text-align: right;
	}
	.header-user-div{
		width: 90px;
		height: 50px;
		float: right;
		text-align: center;
		font-size: 12px;
		cursor: pointer;
	}
	.header-user-img{
		width: 30px;
		height: 30px;
		border-radius: 50%;
		background-color: white;
	}
	.footer-left,.footer-center,.footer-right{
		line-height: 30px;
	}
	.footer-center{
		text-align: center;
	}
	.footer-right{
		text-align: right;
	}
	.hskd{
		width: 100% !important;
	}
	.drawer{
		padding: 0 20px;
		overflow-y: auto;
	}
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 80px;
		height: 80px;
		line-height: 80px;
		text-align: center;
		border: 1px solid #d9d9d9;
		border-radius: 5px;
	}
	.avatar {
		width: 80px;
		height: 80px;
		border: 1px solid #d9d9d9;
		border-radius: 5px;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.div-main{
			padding: 5px 0px;
		}
		.avatar-uploader-icon {
			font-size: 14px;
			width: 60px;
			height: 60px;
			line-height: 60px;
		}
		.avatar {
			width: 60px;
			height: 60px;
		}
		.el-drawer__header {
			margin-bottom: 10px !important;
			padding: 10px 20px !important;
		}
	}
</style>
